module.exports = __webpack_public_path__ + "img/scene_jazz_big@2x.eb67180b.png";